
import React from 'react';

const MailboxSetupSection = () => {
  return (
    <div className="bg-gray-50 rounded-lg p-8 mb-12 shadow-xl">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">How To Set Up 7,000 Mailboxes Capable Of 200 Emails A Day Each (For less than $500)</h2>
      
      <div className="mt-8">
        <img 
          src="/lovable-uploads/c659450e-5526-45a1-ac80-79cb2402cc73.png" 
          alt="Email accounts management dashboard showing multiple email accounts with daily limit of 200 emails" 
          className="rounded-lg shadow-xl max-w-full mx-auto"
        />
      </div>
    </div>
  );
};

export default MailboxSetupSection;
